import { Injectable } from '@angular/core';
import { CanActivate, Router } from '@angular/router';
import { LoginService } from './login.service';

@Injectable({
  providedIn: 'root'
})
export class LoginCanActiveService implements CanActivate {
  
  constructor(private loginService: LoginService, private router: Router) { }

  canActivate() {
    if (this.loginService.IsAccessTokenExpired()) {
      this.router.navigate(['']);
      return false;
    } else {
      return true;
    }
  }
}
